import { FaBuildingWheat } from "react-icons/fa6";
import { ArrowRightToLine, Building, Component, Settings2, User } from "lucide-react";
import { camelize, getApiCEP, getApiCNPJ } from "../commons/utils";

const options_tipo_pessoa = [
    { value: 0, label: 'Física' },
    { value: 1, label: 'Jurídica' },
    { value: 2, label: 'Estrangeira' }
]

function changeTipoPessoa(_newValue: any, refs: any) {
    refs.current['empcpfcnpj'].setLabel(_newValue.value === 0 ? 'CPF' : _newValue.value === 1 ? 'CNPJ' : 'Documento');
    refs.current['empcpfcnpj'].setModel(_newValue.value === 0 ? 'cpf' : _newValue.value === 1 ? 'cnpj' : '');
}

async function changeCNPJ(_newValue: any, refs: any) {
    if ((_newValue.length === 18) && (refs.current['emptipopessoa'].getValue() === 1)) {
        refs.current['empcpfcnpj'].setMsgInfo('Pesquisando CNPJ...');

        await getApiCNPJ(_newValue)
            .then((data: any) => {
                refs.current['empie'].setValue(camelize(data.estabelecimento?.inscricoes_estaduais[0]?.inscricao_estadual));
                refs.current['empnome'].setValue(camelize(data.razao_social));
                refs.current['empcep'].setValue(data.estabelecimento.cep.replace(/(\d{5})(\d{0,3})/, '$1-$2'));
                refs.current['empendereco'].setValue(camelize(data.estabelecimento.tipo_logradouro) + ' ' + camelize(data.estabelecimento.logradouro));
                refs.current['empendnumero'].setValue(data.estabelecimento.numero);
                refs.current['empbairro'].setValue(camelize(data.estabelecimento.bairro));
                refs.current['empmunicipio'].setValue(data.estabelecimento.cidade.nome);
                refs.current['empuf'].setValue(data.estabelecimento.estado.sigla);
            })
            .catch((error: any) => {
                console.log(error)
            })
            .finally(() => {
                refs.current['empcpfcnpj'].setMsgInfo('')
            })
    }
}

function changeCEP(_newValue: any, refs: any) {
    if (_newValue.length === 9) {
        getApiCEP(_newValue.replace('-', ''))
            .then((data: any) => {
                if (data.logradouro)
                    refs.current['empendereco'].setValue(data.logradouro);

                if (data.bairro)
                    refs.current['empbairro'].setValue(data.bairro);

                refs.current['empmunicipio'].setValue(data.localidade);
                refs.current['empuf'].setValue(data.uf);
            })
            .catch((error: any) => {
                console.log(error)
            })
    }
}

export const model_usuario = {
    icon: <User />,
    name: 'Usuário',
    key: 'usucodigo',
    description_field: 'usunome',
    inactive_field: 'usuativo',
    api_get: '/v1/usuario',
    api_post: '/v1/usuarioone',
    inputs: [
        { id: 'usuemail', label: 'E-mail', type: 'text', md: 12, required: true, model: 'email' },
        { id: 'usunome', label: 'Nome', type: 'text', md: 12, required: false },
    ],
    base: {
        usunome: ''
    }
}

export const model_grupo_consulta = {
    name: 'Grupo',
    key: 'gruid',
    description_field: 'grudescricao',
    api_get: '/v1/grupoonlyuser',
}

export const model_grupo = {
    icon: <FaBuildingWheat />,
    name: 'Grupo',
    key: 'gruid',
    description_field: 'grudescricao',
    api_get: '/v1/grupoonlyuser',
    api_post: '/v1/newgrupo',
    inputs: [
        { id: 'gruid', label: 'Código', type: 'number', md: 3, disabled: true, required: true },
        { id: 'grudescricao', label: 'Descrição', type: 'text', md: 9, required: true },
        { id: 'gruidpai', label: 'Grupo Pai', type: 'select', md: 12, model: model_grupo_consulta }
    ],
    base: {
        gruativo: 1,
        grutipo: 0
    }
}

export const model_programacao_coleta_consulta = {
    name: 'Programação de Coleta',
    key: 'progid',
    description_field: 'progdescricao',
    api_get: '/v1/programacaocoleta',
}

export const model_aplicativo_usuario = {
    icon: <Settings2 />,
    name: 'Liberação de Aplicativos',
    key: 'aplicodigo',
    description_field: 'aplinome',
    api_get: '/v1/aplicativotouser',
}

export const model_empresa = {
    icon: <Building />,
    name: 'Empresa',
    key: 'gruempid',
    api_get: '/v1/grupoempresacrm',
    api_post: '/v1/grupoempresacrm',
    description_field: 'empnome',
    inputs: [
        { id: 'gruid', label: 'Grupo', type: 'select', model: model_grupo, md: 3, required: true, disableEdit: true },
        { id: 'emptipopessoa', label: 'Tipo Pessoa', type: 'select', md: 3, options: options_tipo_pessoa, onAfterChange: changeTipoPessoa },
        { id: 'empcpfcnpj', label: 'CPF', type: 'text', md: 3, maxLength: 20, onAfterChange: changeCNPJ },
        { id: 'empie', label: 'IE', type: 'text', md: 3, maxLength: 20 },
        { id: 'empnome', label: 'Nome', type: 'text', md: 6, required: true, maxLength: 100 },
        { id: 'empcep', label: 'CEP', type: 'text', md: 3, maxLength: 10, model: 'cep', onAfterChange: changeCEP },
        { id: 'empendereco', label: 'Endereço', type: 'text', md: 7, maxLength: 200 },
        { id: 'empendnumero', label: 'Número', type: 'text', md: 2, maxLength: 10 },
        { id: 'empbairro', label: 'Bairro', type: 'text', md: 5, maxLength: 50 },
        { id: 'empmunicipio', label: 'Município', type: 'text', md: 5, maxLength: 50 },
        { id: 'empuf', label: 'UF', type: 'text', md: 2, maxLength: 2 },
        { id: 'empurllogo', label: 'URL Logo', type: 'text', md: 12, maxLength: 200 },
    ],
    base: {
    },
    size: 'lg'
}

export const model_causa = {
    icon: <ArrowRightToLine />,
    name: 'Causa',
    key: 'cauid',
    api_get: '/v1/causa',
    api_post: '/v1/causa',
    description_field: 'caudescricao',
    inactive_field: 'cauativo',
    inputs: [
        { id: 'cauid', label: 'Código', type: 'text', md: 12, disabled: true, required: true },
        { id: 'caudescricao', label: 'Descrição', type: 'text', md: 12, required: true, maxLength: 100 },
    ],
    base: {
        cauativo: 1
    }
}

export const model_categoria = {
    icon: <Component />,
    name: 'Categoria',
    key: 'catid',
    api_get: '/v1/categoria',
    api_post: '/v1/categoria',
    description_field: 'catdescricao',
    inactive_field: 'catativo',
    inputs: [
        { id: 'catid', label: 'Código', type: 'text', md: 12, disabled: true, required: true },
        { id: 'catdescricao', label: 'Descrição', type: 'text', md: 12, required: true, maxLength: 100 },
        { id: 'cauid', label: 'Causa', type: 'select', model: model_causa, md: 12 },
    ],
    base: {
        catativo: 1
    }
}
